import { Role } from './types'

export const createRoleOptions = (roleDefinitions: Role[]) => {
  return roleDefinitions?.map(role => ({ groupId: role.department, label: role.name, value: role.id }))
}
